import { isbot } from 'isbot'

const USER_AGENT = 'user-agent'

/**
  Только серверный middleware!
  Нужен для установки в контекст Nuxt приложения флага, для управления ssr запросами
*/
export default defineNuxtRouteMiddleware(() => {
  if (!import.meta.server) return

  const headers = useRequestHeaders([USER_AGENT])
  const ua = headers[USER_AGENT]
  const isBot = isbot(ua)

  if (isBot) {
    const nuxtApp = useNuxtApp()

    if (nuxtApp.ssrContext) {
      nuxtApp.ssrContext.isBot = true
    }
  }

  return
})
